<template>
  <div>
    <div id="usvmap" ref="usvmap" :style="{ height: height + 'px'}" />
    <div v-if="$parent.isApiLoading" class="api-loading-indicator">
      <i class="fas fa-sync-alt fa-spin" />
      <span class="ml-2">Updating...</span>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import { mapStores } from 'pinia';
import { useFleetStore } from '@/stores/fleet';
import { useMomentaryStore } from '@/stores/momentary';
import { ContextMenu, ContextMenuItem } from "@/utils/context-menu";
import { eventBus } from '@/main'

export default {
  props: ["map", "height"],
  data() {
    return {
      selectedUSV: null
    }
  },
  computed: {
    ...mapStores(useFleetStore),
    ...mapStores(useMomentaryStore)
  },
  mounted() {
    // При инициализации проверяем, есть ли сохраненное состояние карты
    this.restoreMapStateIfNeeded();
    eventBus.$on('set_selected_usv', (id) => {
      this.selectedUSV = id;
    })
  },
  beforeDestroy() {
    eventBus.$off('set_selected_usv');

    // Принудительная очистка ресурсов карты
    if (this.map) {
      try {
        // Убираем все event listeners
        if (this.map.map) {
          this.map.map.off();
        }

        // Принудительно очищаем все DOM элементы карты
        const mapContainer = this.$refs.usvmap;
        if (mapContainer) {
          mapContainer.innerHTML = '';
        }

        // Вызываем destroy карты (не изменяем prop напрямую)
        this.map.destroy();

        // Уведомляем родительский компонент о необходимости очистки
        this.$emit('map-destroyed');
      } catch (error) {
        console.warn('Ошибка при очистке карты:', error);
      }
    }
  },

  methods: {

    // Инициализация карты
    async initMap() {
      await this.map.init(this.$refs.usvmap, ["osm", "amap", "google", "primar", "weather"])
      await this.map.initLayers()

      this.map.map.on('click', (e) => {
        console.log(e.latlng);
        L.DomEvent.stop(e);
      })

      this.map.map.on('contextmenu', (e) => {
        console.log('oncontextmenu', e.latlng);

        if (this.selectedUSV === null || this.selectedUSV === '') {
          return; // Нет выбранного USV, не показываем контекстное меню
        }

        const latlng = e.latlng;
        const x = e.originalEvent.clientX;
        const y = e.originalEvent.clientY;

        ContextMenu.closeContextMenu();
        const items = [
            ContextMenuItem(
                'Head this way',
                () => {
                  eventBus.$emit('usv_set_bearing', { lat: latlng.lat, lng: latlng.lng });
                }, 
                true
            ),
            ContextMenuItem(
                'Navigate to this point',
                () => {
                  eventBus.$emit('usv_navigate_to_point', { lat: latlng.lat, lng: latlng.lng });
                }, 
                true
            ),
        ];
        ContextMenu.contextMenuHandler({ x, y, items });
        L.DomEvent.stop(e);
      }) 
    },

    invalidateSize() {
      if (this.map && this.map.map) {
        this.map.map.invalidateSize();
      }
    },

    // Восстановление состояния карты при переключении между вкладками
    restoreMapStateIfNeeded() {
      if (!this.map || !this.map.map) return;

      const savedState = this.momentaryStore.getMapState();
      this.map.map.setView([savedState.lat, savedState.lon], savedState.zoom);
    }
  }
}
</script>

<style scoped>
.api-loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(60, 60, 60, 0.7);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  z-index: 1050;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.api-loading-indicator i {
  margin-right: 6px;
}

#mymap {
  z-index: 1;
}
</style>
